import React from 'react';
import styled from '@emotion/styled';

const SubNavLink = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem 0.75rem 1rem 3rem;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  color: #c8dff0;
  overflow: visible;
  text-overflow: ellipsis;
  white-space: nowrap;

  :hover {
    background-color: #57a8e6;
    color: #ffffff;
  }
`;

interface Props {
  link: string;
  linkText: string;
}

const SubNavItem = (props: Props) => {
  return <SubNavLink href={props.link}>{props.linkText}</SubNavLink>;
};

export default SubNavItem;
